import React from 'react'
import DashboardCard from './DashboardCard'

interface Props {
  weapons: number
}

export default function WeaponsCard({ weapons }: Props) {
  return (
    <DashboardCard
      to="/weapons"
      gradient="linear-gradient(135deg, #5c1a2e 0%, #3d0f1e 60%, #7a2040 100%)"
      accentColor="#ffb3c6"
      badgeIcon="bi-safe2-fill"
      badgeLabel="MEU ACERVO"
      title="ARMAS REGISTRADAS"
      watermarkIcon="bi-safe2"
      topRightIcon="bi-safe2-fill"
      metaLabel="TOTAL DE ARMAS"
      value={weapons || '0'}
      valueSuffix={`arma${weapons !== 1 ? 's' : ''}`}
    />
  )
}
